<template>
  <div class="authorize-container">
    <div class="table-header">
      <p>Ủy quyền quyền hạn cho vai trò</p>
      <button @click="refreshData" class="btn">Làm mới dữ liệu</button>
    </div>

    <div class="content">
      <div class="row">
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Vai trò</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td>
                <input v-model="filterRole" placeholder="Tên vai trò" class="input-control"/>
              </td>
            </tr>
            <tr v-for="(ctt, i) in filterRoles" :key="i" @click="setClickedRow(ctt.role_id)" :class="{ 'bg-green': clickedRow === ctt.role_id }">
              <td>
                <div v-if="clickedRow === ctt.role_id">
                  <i class="fa-solid fa-check"></i>
                </div>
              </td>
              <td>{{ ctt.role_name }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="row" style="width: 80%;">
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Nhóm quyền</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td>
                <input v-model="filterGroupText" placeholder="Tên nhóm" class="input-control"/>
              </td>
            </tr>
            <tr v-for="(ctt, i) in filterGroup" :key="i" @click="setClickedRowGroup(ctt.id)" :class="{ 'bg-green': clickedRow === ctt.role_id }">
              <td>
                <div v-if="clickGroup === ctt.id">
                  <i class="fa-solid fa-check"></i>
                </div>
              </td>
              <td>{{ ctt.name }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="row">
        <table v-if="clickedRow && clickGroup">
          <thead>
            <tr>
              <th></th>
              <th>Quyền hạn</th>
              <th>Mô tả</th>
            </tr>
          </thead>
            <tbody>
              <tr>
              <td></td>
              <td>
                <input v-model="filterName" placeholder="Tên quyền" class="input-control"/>
              </td>
              <td>
                <input v-model="filterDescription" placeholder="Mô tả" class="input-control"/>
              </td>
            </tr>
              <tr v-for="(ctt, i) in filterPermissions" :key="i">
                <td><input type="checkbox" :value="ctt.permission_id" v-model="permissionIdsForRole" @change="handleCheckboxChange(ctt.permission_id)"></td>
                <td>{{ ctt.permission_name}}</td>
                <td>{{ ctt.description }}</td>
              </tr>
            </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      clickedRow: null,
      isLoading: false,
      permissionIdsForRole: [],
      originalPermissionIdsForRole: [],
      status: null,
      filterRole: '',
      filterName: '',
      filterDescription: '',
      filterGroupText: '',
      clickGroup: null,
      selectedRoleId: null
    }
  },
  computed: {
    getPermissions () {
      return this.$store.getters['permissions/backendPermissions']
    },
    getRoles () {
      return this.$store.getters['roles/backendRoles']
    },
    getGroupPermissions () {
      return this.$store.getters['groupPermission/backendGroupPermissions']
    },
    getRolePermissions () {
      return this.$store.getters['authorize/backendRolePermissions']
    },
    filterRoles () {
      if (!this.filterRole) {
        return this.getRoles
      }
      this.resetClickRow()
      const searchTerm = this.filterRole.toLowerCase()
      return this.getRoles.filter(data =>
        data.role_name.toLowerCase().includes(searchTerm)
      )
    },
    filterGroup () {
      if (!this.filterGroupText) {
        return this.getGroupPermissions
      }
      this.resetClickRow()
      const searchTerm = this.filterGroupText.toLowerCase()
      return this.getGroupPermissions.filter(data =>
        data.name.toLowerCase().includes(searchTerm)
      )
    },
    filterPermissions () {
      if (!this.filterName && !this.filterDescription) {
        if (this.clickGroup != null) {
          return this.getPermissions.filter(data => data.groupPermissionId === this.clickGroup)
        }
        return []
      }

      const searchTerm = this.filterName.toLowerCase()
      const searchTerm1 = this.filterDescription.toLowerCase()
      let searchData = this.getPermissions.filter(data => data.groupPermissionId === this.clickGroup)

      if (!this.filterName) {
        searchData = searchData.filter(data =>
          data.description.toLowerCase().includes(searchTerm1)
        )
      }

      searchData = searchData.filter(data =>
        data.permission_name.toLowerCase().includes(searchTerm)
      )
      searchData = searchData.filter(data =>
        data.description.toLowerCase().includes(searchTerm1)
      )

      return searchData
    }
  },
  methods: {
    async getData () {
      this.isLoading = true
      await this.$store.dispatch('permissions/getPermissionData')
      await this.$store.dispatch('roles/getRoleData')
      await this.$store.dispatch('authorize/getRolePermissionData')
      await this.$store.dispatch('groupPermission/getGroupPermissionsData')
      this.isLoading = false
    },
    async refreshData () {
      await this.$store.dispatch('authorize/getRolePermissionData')
      if (this.selectedRoleId) {
        const filterOrigin = this.getRolePermissions.filter(item => item.role_id === this.selectedRoleId)
        this.originalPermissionIdsForRole = filterOrigin.map(item => item.permission_id)
      }
    },
    setClickedRowGroup (id) {
      this.clickGroup = id
    },
    setClickedRow (index) {
      this.clickedRow = index
      this.search(index)
    },
    search (index) {
      const filter = this.getRolePermissions.filter(item => item.role_id === index && item.deleted_at === null)
      this.permissionIdsForRole = filter.map(item => item.permission_id)
      const filterOrigin = this.getRolePermissions.filter(item => item.role_id === index)
      this.originalPermissionIdsForRole = filterOrigin.map(item => item.permission_id)
      this.selectedRoleId = index
    },
    checkStatus (permissionId) {
      if (this.originalPermissionIdsForRole.includes(permissionId)) {
        this.status = true // Already have it
      } else {
        this.status = false // Don't have it yet
      }
    },
    async handleCheckboxChange (permissionId) {
      this.checkStatus(permissionId)
      if (this.permissionIdsForRole.includes(permissionId)) {
        // Checkbox checked, add permissionId to the list
        const additionAdjust = {
          Ids: [this.clickedRow, permissionId],
          permission_id: permissionId,
          role_id: this.clickedRow,
          status: this.status,
          adjustment: true
        }

        try {
          await this.$store.dispatch('authorize/adjustRolePermission', additionAdjust)
          this.refreshData()
          this.$showSuccess('Thêm thành công')
        } catch (error) {
          this.$showError('Đã có lỗi xảy ra')
        }
      } else {
      // Checkbox unchecked, remove permissionId from the list
        const subtractionAdjust = {
          Ids: [this.clickedRow, permissionId],
          permission_id: permissionId,
          role_id: this.clickedRow,
          status: this.status,
          adjustment: false
        }

        try {
          await this.$store.dispatch('authorize/adjustRolePermission', subtractionAdjust)
          this.refreshData()
          this.$showSuccess('Bỏ thành công')
        } catch (error) {
          this.$showError('Đã có lỗi xảy ra')
        }
      }
      await this.refreshData()
    },
    resetClickRow () {
      this.clickedRow = null
      this.clickGroup = null
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style scoped>
.authorize-container {
    width: 100%;
  }

  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: rgb(240, 240, 240);
    flex-wrap: wrap;
  }

  .table-header p {
    color: #000;
  }

  button {
    outline: none;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    padding: 10px;
    color: #fff;
  }

  .btn {
    padding: 10px 20px;
    color: #fff;
    background-color: #0298cf;
  }

  .table-header input {
    padding: 10px 20px;
    margin: 0 10px;
    outline: none;
    border: 1px solid #0298cf;
    border-radius: 6px;
    color: #0298cf;
  }

  ::placeholder {
    color: #0298cf;
  }

  .content {
    display: flex;
    flex-direction: row;
    gap: 50px
  }

  .row {
    flex: 1;
  }

  table {
    width: 100%;
    table-layout: auto;
    border-collapse: collapse;
  }

  td:nth-child(1), td:nth-child(2) {
    text-align: left;
  }

  th:nth-child(1), td:nth-child(1) {
    width: 60px;
  }

  thead th {
    position: sticky;
    top: 0;
    background-color: #0298cf;
    color: #fff;
    font-size: 15px;
    height: 50px;
  }

  th,td {
    border-bottom: 1px solid #dddddd;
    padding: 10px 20px;
    text-align: left;
    border-right: 1px solid #dddddd;
    border-left: 1px solid #dddddd;
  }

  tr:hover td {
    background-color: #cfe2ff;
  }

  tr:nth-child(even) {background-color: #ececec }

  .bg-green {
    background-color: #7baefa !important;
  }

  .input-control {
    width: 100%;
    padding: 10px 20px;
    outline: none;
    border: 1px solid #0298cf;
    border-radius: 6px;
    color: #0298cf;
  }
</style>
